<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container = undefined;
export let source = undefined;
export let days = undefined;
export let sortAscending = undefined;
export let pollSeconds = undefined;
</script>

<BaseAtom _isotope="NVPlayMatchListAtom" {...container}>
  <div>NVPlayMatchListAtom</div>
</BaseAtom>
